import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=4068ee39&scoped=true&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Card.vue?vue&type=style&index=0&id=4068ee39&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4068ee39",
  null
  ,true
)

export default component.exports